import React, { useEffect } from "react";
import Changes from "./Changes";

function ChangesSinceVersion({
  versions,
  changesSince,
  changesIn,
  project_id,
  isLoading,
  account_slug,
  authorizationCode,
}) {
  useEffect(() => {}, [isLoading]);

  if (isLoading) {
    return (
      <div>
        <ScopeStackSpinner />
      </div>
    );
  } else {
    return (
      <Changes
        versions={versions}
        changesSince={changesSince}
        changesIn={changesIn}
        project_id={project_id}
        account_slug={account_slug}
        authorizationCode={authorizationCode}
      />
    );
  }
}

export default ChangesSinceVersion;
